// extracted by mini-css-extract-plugin
export default {"sideExplainer":"dhbrm__sideExplainer--a1ccb","leftBorder":"dhbrm__leftBorder--ad2c5","rightBorder":"dhbrm__rightBorder--d21b3","text":"dhbrm__text--b7696"};